import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";
import { formatPrice } from "utils/formatPrice";

import type { CheckInResult } from "models";

type CheckinResultProps = {
  results: CheckInResult[];
};

export const CheckinResults = ({ results }: CheckinResultProps) => {
  const selectedLocation = useAppointmentLocation();
  const { t } = useTranslation();

  if (!results.length) return null;

  return (
    <div className="info-section">
      <div className="section-header">{t("v8_extra_services", "Extra services")}</div>
      <div className="section-content">
        <Grid>
          <Grid.Column width={16}>
            <div className="services-header">
              <span>{t("v8_title", "Title")}</span>
              <span>{selectedLocation?.include_vat ? t("v8_price_inc_vat", "Price (incl. VAT)") : t("v8_price_excl_vat", "Price (excl. VAT)")}</span>
            </div>
            {results
              .filter(r => r.accepted)
              .map((result, key) => (
                <div className="service" key={key}>
                  <div className="service-title-remark-container">
                    <span>{result.name}</span>
                  </div>
                  <div className="service-price-container">
                    <span>
                      {selectedLocation?.include_vat
                        ? formatPrice(Number((result.price * (1 + (selectedLocation.vat || 0) / 100)).toFixed(2)))
                        : formatPrice(result.price)}{" "}
                      €
                    </span>
                  </div>
                </div>
              ))}
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );
};
